import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e7e56ec8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "detail-box" }
const _hoisted_4 = { class: "text-box" }


export default /*#__PURE__*/_defineComponent({
  emits: ["exit"],
  setup(__props, { emit }) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "close-web",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('exit')))
          }),
          _renderSlot(_ctx.$slots, "default")
        ])
      ])
    ])
  ]))
}
}

})